<template>
  <div style="height: 100%;">
    <v-card style="height: 100%;">
      <v-card-title class="primary white--text py-2">
        <h3>Clearance</h3>
        <v-spacer></v-spacer>
        <div class="d-flex align-center" style="color: white !important;">
          <v-select
            :items="sessions"
            v-model="session"
            outlined
            dense
            item-text="name"
            placeholder="Session"
            return-object
            dark
            class="white--text pa-0 ma-0 my-0"
            style=""
            hide-details
          >
          </v-select>
        </div>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <clearance-history :session="session" />
      </v-card-text>
    </v-card>

  </div>
</template>


<script>

import ClearanceHistory from '../components/StudentClearance.vue';
import { mapGetters } from 'vuex';
import Api from "@/main/api";
export default {
  name: "Clearance",
  components: {
    ClearanceHistory
  },
  data: () => ({
    tab: null,
    session: null,
    sessions: []
  }),

  methods: {
    getSessions(){
      if(this.getUser != null){
        Api.session.getFullPaidSessionsForStudent(this.getUser.userId)
        .then(res => {
          this.sessions = res.data
          // console.log(res.data)
        })
        .catch(err => ErrorReslover.checkErrors(this, err))
      }
    }
  },

  computed: {
    ...mapGetters(['getUser'])
  },

  watch: {
    getUser: function(val){
      if(val)
        this.getSessions()
    }
  },

  created() {
    if(this.getUser){
      this.getSessions()
    }
  }
}
</script>
